import { render, staticRenderFns } from "./PlanejamentoContratoFluxo.vue?vue&type=template&id=be3ab208"
import script from "./PlanejamentoContratoFluxo.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoFluxo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports